import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { prioridadeLabel } from '../../../ProcedimentoDigitacao/constants';

/** Texto semântico legível nos dois modos (o `.dark` some no fundo escuro). */
const corSemantica = (cor) => (theme) => (
  theme.palette.mode === 'dark' ? theme.palette[cor].light : theme.palette[cor].dark
);

const COR_POR_PRIORIDADE = { ALTA: 'error', MEDIA: 'warning' };

const PrioridadeProcedimentoChip = ({ prioridade }) => {
  if (!prioridade) return null;
  const cor = COR_POR_PRIORIDADE[prioridade];
  const label = prioridadeLabel(prioridade);
  return (
    <Chip
      size="small"
      variant="outlined"
      label={label}
      aria-label={`Importância ${label.toLowerCase()}`}
      sx={cor ? { color: corSemantica(cor), borderColor: `${cor}.main`, flexShrink: 0 } : { flexShrink: 0 }}
    />
  );
};

PrioridadeProcedimentoChip.propTypes = {
  prioridade: PropTypes.string,
};

PrioridadeProcedimentoChip.defaultProps = {
  prioridade: null,
};

export default PrioridadeProcedimentoChip;
